import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import QuickbooksAccountMappingPage from "./QuickbooksAccountMappingPage";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import QuickbooksMappingPage from "../QuickBooksMapping/QuickbooksMappingPage";
import { quickBooksMappingEntityTypes } from "../QuickBooksMapping/QuickBooksMappingConsts";

const QuickbooksTabsPage = () => {
    const tabs = [
        {
            key: "accountMapping",
            label: "QuickBooks Account Mapping",
            component: <QuickbooksAccountMappingPage />,
            permission: permissionProfiles.INVOICE.VIEW_QUICKBOOKS_ACCOUNT_MAPPING
        },
        {
            key: "VendorsMapping",
            label: "Vendors Mapping",
            component: <QuickbooksMappingPage type={quickBooksMappingEntityTypes.VENDOR} title={ 'Vendors Mapping' } />,
            permission: permissionProfiles.INVOICE.VIEW_QUICKBOOKS_ACCOUNT_MAPPING
        },
        {
            key: "ActivityItemsMapping",
            label: "Activity Items Mapping",
            component: <QuickbooksMappingPage type={quickBooksMappingEntityTypes.ACTIVITY_ITEM} title={'Activity Items Mapping'} />,
            permission: permissionProfiles.INVOICE.VIEW_QUICKBOOKS_ACCOUNT_MAPPING
        }
    ];

    return (
        <TabsWrapper tabs={tabs} selectedTab={0} />
    );
};

export default QuickbooksTabsPage;
